export const fmtMoney = (n) => Number(n || 0).toFixed(2);

export const _IsImageFile = (fileNameOrUrl) => {
  return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(fileNameOrUrl)
    || /^(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(fileNameOrUrl);
};

export const extractFatherName = (careOf) => {
  if (!careOf) return "";

  // Matches variants like "S/O:", "D/O:", "C/O:", "W/O:" etc.
  const match = careOf.match(/(?:S\/O|D\/O|C\/O|W\/O)\s*[:-]?\s*(.+)/i);

  if (match && match[1]) {
    return match[1].trim();
  }

  return "";
}

/**
 * Validates if a string is exactly 10 digits with no spaces or special characters.
 * @param {string} value - The string to validate.
 * @returns {boolean} - True if valid, false otherwise.
 */
export const isValidTenDigitNumber = (value) => {
  if (typeof value !== 'string') return false;

  // Regex explanation:
  // ^     : Start of string
  // \d{10}: Exactly 10 digits (0-9)
  // $     : End of string
  const regex = /^\d{10}$/;

  return regex.test(value);
};
